@font-face {
  font-family: "Sofia Pro";
  font-weight: 900;
  src:
    local("Sofia Pro"),
    url(../../SofiaPro-Black-DQnT-woQ.otf) format("opentype");
}

@font-face {
  font-family: "Sofia Pro";
  font-weight: 700;
  src:
    local("Sofia Pro"),
    url(../../SofiaPro-Bold-By7EgT9_.otf) format("opentype");
}

@font-face {
  font-family: "Sofia Pro";
  font-weight: 600;
  src:
    local("Sofia Pro"),
    url(../../SofiaPro-SemiBold-d_87_M7D.otf) format("opentype");
}

@font-face {
  font-family: "Sofia Pro";
  font-weight: 500;
  src:
    local("Sofia Pro"),
    url(../../SofiaPro-Medium-C3PfU8sz.otf) format("opentype");
}

@font-face {
  font-family: "Sofia Pro";
  font-weight: 400;
  src:
    local("Sofia Pro"),
    url(../../SofiaPro-Medium-C3PfU8sz.otf) format("opentype");
}

@font-face {
  font-family: "Sofia Pro";
  font-weight: 300;
  src:
    local("Sofia Pro"),
    url(../../SofiaPro-Light-D9i3kmCr.otf) format("opentype");
}

@font-face {
  font-family: "Sofia Pro";
  font-weight: 200;
  src:
    local("Sofia Pro"),
    url(../../SofiaPro-ExtraLight-CtowbBF_.otf) format("opentype");
}
